<template>
	<div
		class="v-input v-text-field v-text-field--enclosed v-text-field--outline v-input--is-label-active v-input--is-dirty theme--light"
	>
		<div class="v-input__slot">
			<div class="v-text-field__slot">
				<div class="mb-1" v-if="label">
					<label class="v-label v-label--active theme--light">{{ label }}</label>
				</div>
				<div class="image-select mb-3">
					<img
						v-if="source"
						:src="source"
						:width="imageWidth"
						:height="imageHeight"
						class="image-select__img"
					/>

					<div
						v-else
						class="image-select__placeholder"
						:style="`height: ${imageHeight}px; width: ${imageWidth}px`"
					></div>

					<div class="image-select__actions">
						<v-tooltip top>
							<template v-slot:activator="{ on }">
								<v-btn color="primary" light class="ma-1" icon small @click="selectImage" v-on="on">
									<fa-icon icon="pencil-alt" />
								</v-btn>
							</template>
							<span>Edit</span>
						</v-tooltip>

						<v-tooltip top v-if="newImage">
							<template v-slot:activator="{ on }">
								<v-btn color="primary" light icon small class="ma-1" @click="resetImage" v-on="on">
									<fa-icon icon="times" />
								</v-btn>
							</template>
							<span>Reset</span>
						</v-tooltip>
					</div>
					<input
						style="display:none;"
						type="file"
						:accept="availableImageTypes"
						ref="image"
						@change="changeImage"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { log } from "util";

export default {
	data() {
		return {
			imageSrc: "",
			imageRatio: 1,
			imageWidth: 150,
			imageHeight: 150,
			imageBlob: null,
			newImage: false
		};
	},

	props: {
		label: {
			default: "",
			type: String
		},

		reset: {
			default: false,
			type: Boolean
		},

		src: {
			default: "",
			type: String
		}
	},

	computed: {
		availableImageTypes() {
			// return ".jpg, .jpeg, .png, .gif, .svg";
			return ".jpg, .jpeg, .png";
		},

		source() {
			if (this.imageSrc) {
				return this.imageSrc;
			}

			return this.src;
		}

		// imageWidth() {
		// 	return 200;
		// },

		// imageHeight() {
		// 	return 200;
		// }
	},

	methods: {
		selectImage() {
			this.$refs.image.click();
		},

		setImageSrcSizes(url) {
			if (url) {
				let img = new Image();

				img.onload = e => {
					let w = img.width;
					let h = img.height;
					let ratio = h / w;

					this.$set(this, "imageWidth", w);
					this.$set(this, "imageHeight", h);
					this.$set(this, "imageRatio", ratio);
				};

				this.$set(this, "imageSrc", url);

				img.src = url;
			}
		},

		resetImage() {
			this.setImageSrcSizes(this.src);
			this.$refs.image.value = null;
			this.$set(this, "newImage", false);
			this.$set(this, "imageBlob", null);

			this.$nextTick(() => {
				this.$emit("update:reset", false);
			});
		},

		changeImage(value) {
			if (value.target.files.length) {
				this.fr = new FileReader();

				this.fr.onload = e => {
					this.setImageSrcSizes(this.fr.result);
				};

				this.imageBlob = value.target.files[0];

				this.fr.readAsDataURL(this.imageBlob);

				this.$set(this, "newImage", true);
			} else {
				this.resetImage();
			}

			this.$emit("input", this.imageBlob);
		}
	},

	created() {
		this.setImageSrcSizes(this.src);
	},

	watch: {
		reset(value) {
			if (value) {
				this.resetImage();
			}
		}
	}
};
</script>
